import { z } from 'zod';

export const OrganizationNameSchema = z.object({
  name: z
    .string({ message: 'Organization name is required' })
    .trim()
    .min(1, { message: 'Organization name is required' }),
});

export type OrganizationNameDto = z.infer<typeof OrganizationNameSchema>;
